// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player-swiper-class {\n  width: 1000px;\n}\n\n/* For mobile screens */\n@media (max-width: 768px) {\n.player-swiper-class {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
